import { default as PostCreate } from "./post-create";
import PostCreateFrontLink from "./front-link";

export {
    PostCreateFrontLink
}

export default PostCreate;